import { Suspense } from "react";
import { useTranslation } from "react-i18next";

import type { MapType } from "@lib/store";

import type { MapLibraryProps } from "../types";
import { useFloorMap } from "../useFloorMap";
import { MapiqMapLoading } from "./MapiqMapLoading";
import { MapiqMapMessage } from "./MapiqMapMessage";
import { MapiqMapView } from "./MapiqMapView";

type MapiqMapContentProps = MapLibraryProps & {
  buildingId: string;
  floorId: string;
  mapType: MapType;
  hasSize: boolean;
};

export const MapiqMapContent = ({ buildingId, floorId, mapType, hasSize, ...props }: MapiqMapContentProps) => {
  const { t } = useTranslation();
  const floorMap = useFloorMap({ buildingId, floorId, type: mapType });

  if (floorMap.status === "failed") return <MapiqMapMessage>{t("error:FailedToLoadMap")}</MapiqMapMessage>;
  if (floorMap.status === "loading") return <MapiqMapLoading />;
  if (!hasSize) return null;

  return (
    <Suspense fallback={<MapiqMapLoading />}>
      <MapiqMapView
        mapData={floorMap.mapData}
        {...props}
      />
    </Suspense>
  );
};
